// services
import api from '../../../services/api';
// constants
import { CREATIVE_API } from '../../../constants/api';

export const getCurrentMonth = () => {
  try {
    const date = new Date();
    const month = date.getMonth() + 1; // getMonth() returns 0-11, so add 1 to get 1-12

    if (month < 1 || month > 12) {
      throw new Error('Invalid month value');
    }

    return month;
  } catch (error) {
    console.error('Error getting the current month:', error);
    return new Date().getMonth() + 1; // Fallback to current month
  }
};

export const generateFilterObj = (filters) => {
  return {
    year: filters?.year,
    month: filters?.month,
    creative_type: filters?.creative_type,
    store_id: [filters?.branch],
  };
};

export const fetchCreativesData = async (appliedFilters) => {
  try {
    const response = await api.post(CREATIVE_API, appliedFilters);
    return response?.data;
  } catch (error) {
    console.error('error in fetching creatives data--->', error);
  }
};
